import React, { useEffect, useState } from 'react';
import { Col, Container, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import LogoComponent from '../Logo/LogoComponent';
import shopImg from '../../img/iconoTienda.svg';
import shopImg2 from '../../img/iconoTienda2.svg';
import helpImg from '../../img/ayudaIcono.png';
import helpImg2 from '../../img/ayudaIcono2.png';
import createImg from '../../img/iconoCrear.svg';
import createImg2 from '../../img/iconoCrear2.svg';
import { setShowCreateModal } from '../../redux/modules/show';
import { connect } from 'react-redux';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import { apiUrl, businessUserType1 } from '../../utils/consts';
import ProductCard from '../ProductCard/ProductCard';
import BenefitCard from '../BenefitCard/BenefitCard';
import './styles/home.scss';

const select = state => {
  return {
    user: state.auth.user,
    showCreateModal: state.show.showCreateModal
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setShowCreateModal: show => dispatch(setShowCreateModal(show))
  };
}

function ConnectedHomeComponent(props) {

  const [tab, setTab] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [benefits, setBenefits] = useState([]);
  const isUserType1 = props.user && props.user.nibiBusinessUserType === businessUserType1;

  useEffect(() => {
    if (tab === 2) props.setShowCreateModal({ show: true });
  }, [tab]);

  useEffect(() => {
    if (!props.showCreateModal) setTab(-1);
  }, [props.showCreateModal]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {

    const productsProm = fetch(`${apiUrl}/products/get/random`);
    const benefitsProm = fetch(`${apiUrl}/benefits/get/random`);

    const productsResp = await (await productsProm).json();
    const benefitsResp = await (await benefitsProm).json();

    if (productsResp.success) setProducts(productsResp.products);
    if (benefitsResp.success) setBenefits(benefitsResp.benefits);

    setLoading(false);
  };

  return (
    <div className="home-component">
      <LogoComponent />
      <h1 className="app-title">
        ¿Qué quieres hacer hoy?
      </h1>
      <Container>
        <Row className="justify-content-center">
          <Col md={9}>
            <div style={{ marginTop: '25px', textAlign: 'center', color: '#072450', fontSize: '1.15rem', marginBottom: '15px' }}>
              Compra productos de tu comunidad, ofrece apoyo a quien lo necesita y encuentra ayudas si estás pasando por un momento difícil.
            </div>
          </Col>
        </Row>
        <div className="nav-section">
          <Row className="justify-content-center">
            <Col md={3}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    Encuentra productos y servicios de las familias de la comunidad Cemex
                  </Tooltip>
                }
              >
                <div className={`app-nav-button ${tab === 0 ? 'active' : ''}`} onClick={() => props.history.push('/tienda')}>
                  <img src={tab === 0 ? shopImg : shopImg2} />
                  <span>Explora la tienda</span>
                </div>
              </OverlayTrigger>
            </Col>
            {
              isUserType1 &&
              <Col md={3}>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      Acá puedes ayudar en dinero o especie y solicitar ayudas ofrecidas
                    </Tooltip>
                  }
                >
                  <div className={`app-nav-button ${tab === 1 ? 'active' : ''}`} onClick={() => props.history.push('/seccion_solidaria')}>
                    <img src={tab === 1 ? helpImg2 : helpImg} />
                    <span>Explora el muro de la solidaridad</span>
                  </div>
                </OverlayTrigger>
              </Col>
            }
            <Col md={3}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    Accede rápido a la posibilidad de crear un nuevo producto, ofrecer o solicitar una ayuda
                  </Tooltip>
                }
              >
                <div className={`app-nav-button ${tab === 2 ? 'active' : ''}`} onClick={() => setTab(2)}>
                  <img src={tab === 2 ? createImg2 : createImg} />
                  <span>Crear</span>
                </div>
              </OverlayTrigger>
            </Col>
          </Row>
        </div>
        <div className="highlight-section">
          <h5>Algunos productos de la tienda</h5>
          {
            loading ?
            <AppSpinner /> :
            <Row>
              {
                products.map((item, index) =>
                  <Col key={index} sm={3}>
                    <ProductCard product={item} />
                  </Col>
                )
              }
            </Row>
          }
          <br />

          {
            isUserType1 &&
            <>
              <h5>Muro de la solidaridad</h5>
              {
                loading ?
                <AppSpinner /> :
                <Row>
                  {
                    benefits.map(item =>
                      <Col sm={3} key={item._id}>
                        <BenefitCard benefit={item} />
                      </Col>
                    )
                  }
                </Row>
              }
            </>
          }
        </div>
      </Container>
    </div>
  );
}

const HomeComponent = connect(select, mapDispatchToProps)(ConnectedHomeComponent);

export default HomeComponent;
